/*******************************************************************************
/*******************************************************************************
* BooksServicesProvider */
/**
 * Books common RESTful service calls.
 *******************************************************************************/
/* @ngInject */ export function BooksServicesProvider() {
  this.httpServices = {
    Entities: {
      base: 'BooksSvc.ashx/',
      services: {
        findAddressEntitiesAndStudents: function (value, types, activeOnly) {
          return this.post('findAddressEntitiesAndStudents', {
            value,
            types,
            activeOnly
          });
        },
        getEntityByDirection: function (entityName, next) {
          return this.post('getEntityByDirection', { entityName, next });
        }
      }
    },
    Receipts: {
      base: '/books/receipts/',
      services: {
        /**
         * Used by the LimitedReceiptItemsDialog to check the limiters of the passed in receipt items.
         */
        checkLimitersRestrictions: function (data) {
          return this.post('checkLimitersRestrictions', data);
        },
        emailReceipt: function ({ receiptID, emailAddress }) {
          return this.post('emailReceipt', { receiptID, emailAddress });
        },
        /**
         * Currently only used by the finishAndPayDialog of POS.
         */
        saveReceipt: function (receipt) {
          return this.post('saveReceipt', receipt);
        },
        /**
         * Used by ReceiptsEntityInfoDialog to get a list of receivables for a specific entity or receipt.
         */
        viewReceivablesItems: function (entityID, receiptNumber, batchNumber) {
          return this.post('viewReceivablesItems', {
            entityID: entityID,
            receiptNumber: receiptNumber,
            batchNumber: batchNumber
          });
        },
        /**
         * Used by the site-wide "Refresh" button on the receivables info dialog's
         * Destiny accordion. No-op ({ started: false }) for products without Destiny;
         * ASBWorks overrides the route to kick off a real background refresh.
         */
        refreshDestinyFines: function () {
          return this.post('refreshDestinyFines');
        },
        /**
         * Used by the per-entity "Refresh <student>" button on the receivables info
         * dialog's Destiny accordion. No-op ({ started: false }) for products without
         * Destiny; ASBWorks overrides the route to refresh just this entity's fines.
         */
        refreshDestinyEntityFines: function (entityID) {
          return this.post('refreshDestinyEntityFines', { entityID });
        }
      }
    },
    Session: {
      base: '/books/session/',
      services: {
        getOrganization: function () {
          return this.get('getOrganization');
        }
      }
    },

    Voids: {
      base: '/books/voids/',
      services: {
        dropVoidEntry: function (entryID) {
          return this.get('dropVoidEntry/{0}'.format(entryID));
        },
        getVoidEntry: function (entryID) {
          return this.get('getVoidEntry/{0}'.format(entryID));
        }
      }
    }
  };

  /*******************************************************************************
   * service
   *******************************************************************************/
  this.$get = [
    'HTTPService',
    function (HTTPService) {
      const svcs = {};

      for (const service in this.httpServices) {
        svcs[service] = Object.assign(
          HTTPService.make(this.httpServices[service].base),
          this.httpServices[service].services
        );
      }

      return svcs;
    }
  ];
}
